import styled from 'styled-components/macro'

export const Container = styled.div`
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 9999;
  display: flex;
  max-width: 420px;
`

export const ToastBox = styled.div<{}>`
  background-color: #eff6ff;
  border: 1px solid #C7C7C7;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 20px 16px;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
`

export const ToastText = styled.p`
  flex: 1;
  font-size: 14px;
  color: #1B2F70;
  line-height: 1.5;
`

export const ToastClose = styled.button`
  background: none;
  border: none;
  font-size: 20px;
  line-height: 1;
  color: #6b7280;
  cursor: pointer;
  margin-top: -2px;
`
